// extracted by mini-css-extract-plugin
export var actionButton = "_ik-t";
export var buttonContainer = "_ik-0";
export var buttonContainer2 = "_ik-1";
export var buttonSection = "_ik-2";
export var details = "_ik-3";
export var dropdownItem = "_ik-5";
export var dropdownItemsContainer = "_ik-4";
export var fileInput = "_ik-r";
export var headerButton = "_ik-6";
export var icon = "_ik-7";
export var input = "_ik-8";
export var macroListItem = "_ik-9";
export var mainContent = "_ik-a";
export var microText = "_ik-b";
export var modal = "_ik-w";
export var optionsButton = "_ik-c";
export var paperclip = "_ik-s";
export var pillContent = "_ik-d";
export var preview = "_ik-e";
export var preview2 = "_ik-f";
export var quillEditor = "_ik-q";
export var selectedMacro = "_ik-g";
export var sidebar = "_ik-h";
export var sidebarHeader = "_ik-j";
export var sidebarList = "_ik-i";
export var sidebarListItem = "_ik-k";
export var sidebarSearch = "_ik-l";
export var snoozeDurationWrapper = "_ik-v";
export var statusPillContainer = "_ik-m";
export var tagsContainer = "_ik-n";
export var unselectedMacro = "_ik-o";
export var variable = "_ik-u";
export var wrapper = "_ik-p";